import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import NumpadInputButtons from './numpadInputButtons';
import { userInfoStore } from '../../../store/userInfoStore';
import { handleNumpadButtonsClick } from '../../../core/helpers/handleNumpadButtonsClick';

const NumpadInput = observer(() => {
  const { setBetAmount, betAmount, limits, precision } = userInfoStore;

  const handleButtonsClick = useCallback(
    (options) => handleNumpadButtonsClick(setBetAmount, betAmount, limits, precision, options),
    [betAmount, setBetAmount, precision, limits]
  );

  return (
    <div className='numpad-action-block'>
      <NumpadInputButtons
        option='left'
        isDisabled={betAmount <= limits?.minBet}
        handleClick={() => handleButtonsClick(false)}
      />
      <p className='money-count'>{betAmount}</p>
      <NumpadInputButtons
        option='right'
        isDisabled={betAmount >= limits?.maxBet}
        handleClick={() => handleButtonsClick(true)}
      />
    </div>
  );
});

export default NumpadInput;
